/*
 *  This extension adds hide/show functionality to higcharts v4.1.4
 *  usage example:
 *  1. if(chart.yAxis[0].visible) chart.yAxis[0].hide();
 *  2. if(!chart.xAxis[0].visible) chart.xAxis[0].show();
 */
(function (H) {
    var UNDEFINED;

    H.wrap(H.Axis.prototype, 'render', function (p) {
        if (typeof this.visible === 'undefined')
            this.visible = true;

        if (this.visible) {
            this.min = this.prevMin || this.min;
            this.max = this.prevMax || this.max;
        } else {
            this.prevMin = this.min;
            this.prevMax = this.max;
            this.min = UNDEFINED;
            this.max = UNDEFINED;
        }

        this.hasData = this.visible;

        p.call(this);
    });

    H.Axis.prototype.hide = function () {
        this.visible = false;
        this.render();

        H.each(this.plotLinesAndBands, function (plotLine) {
            plotLine.render();
        });
    };

    H.Axis.prototype.show = function () {
        this.visible = true;
        this.render();

        H.each(this.plotLinesAndBands, function (plotLine) {
            plotLine.render();
        });
    };
}(Highcharts));